import React, { useState } from "react";
import { OuterBox } from "components/GhiPlanSetup/styles";
import BaseTickBox from "components/Flex/TickBox";

const WellnessBenefits = ({ formikProps, displayVlaues, onChange }) => {
  const [selectValueList, setSelectedValueList] = useState(
    Array.from({ length: displayVlaues.length }, () => false)
  );
  // console.log(formikProps.values.wellness_benefits, selectValueList, displayVlaues)
  const handleChange = (event, index) => {
    const isChecked = event.target.checked;
    const selectedValues = [...selectValueList];
    selectedValues[index] = isChecked;
    const newArray = displayVlaues.filter((_, index)=> selectedValues[index]).map(obj => obj.value);
    console.log({newArray})
    formikProps.values.wellness_benefits = newArray
    setSelectedValueList(selectedValues);
    onChange(selectedValues);
  };
  return (
    <OuterBox>
      {
        displayVlaues.map((value, index)=> (
          <BaseTickBox
          attribute={value.display_name}
          key={index}
          selected={selectValueList[index]}
          onChange={(event)=> handleChange(event, index)}
          />
        ))
      }
    </OuterBox>
  );
};

export default WellnessBenefits
